import React from 'react';
import { MdThumbUp } from 'react-icons/md';
import CopyrightInfo from '../Common/CopyrightInfo';

export default function RGPDSigned({ clientName }) {
  return (
    <div className="text-center">
      <div className="flex justify-center items-center rounded-md bg-green-100 py-3 px-6 text-green-800 mb-6">
        <MdThumbUp className="h-5 w-5 text-green-700 mr-2" />
        <span className="font-bold text-base md:text-base text-xs">
          Obrigado, {clientName?.split(' ')[0] || 'Cliente'}!
        </span>
      </div>

      <p className="text-gray-700 text-base mb-3">
        O seu consentimento RGPD foi <b>assinado digitalmente</b> e já se encontra registado no
        processo.
      </p>

      <p className="text-gray-600 text-sm mt-2">
        Receberá uma cópia por email com o comprovativo da assinatura.
      </p>

      <CopyrightInfo className="mt-10" />
    </div>
  );
}